import { appContext } from '@provider/app-context';
import { bindGlobalEvents, onPrintDialogTriggered, registerOnBeforePrintCallback } from './before-print/_before-print.js';
import { populatePrintTarget } from './populate-print-target/_populate-print-target.js';
import { setupPrintStylesheet } from './populate-print-target/util.setup-stylesheet.js';

const printManager = {
  triggerPrintDialog: async options => {
    onPrintDialogTriggered();
    if (options?.incompatibleContent) {
      setupPrintStylesheet(undefined);
    }
    if (options?.afterPrint) {
      window.addEventListener("afterprint", options.afterPrint, {
        once: true
      });
    }

    // window.print() is not enough to trigger print reliably in Safari,
    // See https://stackoverflow.com/questions/31171099/window-print-does-not-work-in-safari
    try {
      if (!document.execCommand("print", false, undefined)) {
        window.print();
      }
    } catch {
      window.print();
    }
  },
  preparePrint: async (key, target, input) => {
    const {
      debug = false
    } = input;
    await Promise.all([new Promise(resolve => {
      setupPrintStylesheet(input.format, debug);
      populatePrintTarget(`${key}-${target}-${input.format}`, target, input, resolve);
    }), appContext.getPageAuthors()]);
  },
  registerBeforePrintHandler: onBeforePrint => {
    registerOnBeforePrintCallback(onBeforePrint);
    bindGlobalEvents();
  },
  reset: () => {
    registerOnBeforePrintCallback(undefined);
    setupPrintStylesheet(undefined);
    populatePrintTarget("__clear__", "browser", {
      sections: [],
      format: "A4-landscape"
    });
  }
};

export { printManager };
//# sourceMappingURL=manager.js.map
